import { ControlNumberField } from 'components/Form';
import type { WorkOrderStatusEnum, BimWorkOrderOtherDistributionData } from 'gql/graphql';
import { OtherCostCalculationTypeEnum } from 'gql/graphql';
import { GridItem, cnMixSpace } from 'uikit';

import { useEffect } from 'react';
import type { Control, UseFormSetValue } from 'react-hook-form';

const MARGIN_BOTTOM = cnMixSpace({ mB: 's' });

export const BimDistributionOtherLimits = ({
    control,
    distributionData,
    setValue,
    isFrameContract,
    isWorkOrderChange,
}: {
    control: Control;
    distributionData: BimWorkOrderOtherDistributionData | undefined | null;
    setValue?: UseFormSetValue<any>;
    statusWorkOrder?: WorkOrderStatusEnum;
    isFrameContract?: boolean;
    isWorkOrderChange?: boolean;
}) => {
    const isCalculatingTypeCalculation =
        distributionData?.contractOtherCost?.calculatingType === OtherCostCalculationTypeEnum.Calculation;
    const limitData = distributionData?.limit;

    useEffect(() => {
        setValue?.('cost', limitData?.costLimit);
        setValue?.('totalRemainderCost', limitData?.totalRemainderCost);
        setValue?.('includedCost', limitData?.includedCost);
    }, [limitData?.costLimit, limitData?.includedCost, limitData?.totalRemainderCost, setValue]);

    const labelWorkOrderWithChange = `${isWorkOrderChange ? 'Изм к НЗ' : 'НЗ'}`;
    const labelIncludedCost = `Включить в ${isFrameContract ? labelWorkOrderWithChange : 'расчет'}`;

    return (
        <>
            <GridItem className={MARGIN_BOTTOM}>
                <ControlNumberField
                    name="cost"
                    label="Лимит по Договору"
                    labelPosition="left"
                    control={control}
                    size="s"
                    disabled
                    decimalScale={0}
                    style={{ width: '100%' }}
                />
            </GridItem>
            <GridItem className={MARGIN_BOTTOM}>
                <ControlNumberField
                    name="totalRemainderCost"
                    label="Остаток"
                    labelPosition="left"
                    control={control}
                    size="s"
                    disabled
                    decimalScale={0}
                    style={{ width: '100%' }}
                />
            </GridItem>
            {isCalculatingTypeCalculation && (
                <GridItem className={MARGIN_BOTTOM}>
                    <ControlNumberField
                        name="includedCost"
                        label={labelIncludedCost}
                        labelPosition="left"
                        control={control}
                        size="s"
                        decimalScale={0}
                        style={{ width: '100%' }}
                        disabled={!isFrameContract}
                    />
                </GridItem>
            )}
        </>
    );
};

BimDistributionOtherLimits.displayName = 'BimDistributionOtherLimits';
